import { CoverageCheckupState } from '../../store/step';
import {
  CoverageCheckupPayload,
  HomeWorth,
  MortgageBalance,
  TrueFalse,
  YesNo,
  YesNoNotSure,
  ZeroOne,
} from '../../types';

function convertToTrueFalse(value: YesNoNotSure): TrueFalse {
  return value === 'yes' ? 'true' : 'false';
}

function convertBooleanToBinaryString(value: boolean): ZeroOne {
  return value ? '1' : '0';
}

function convertToMortgageBalance(value: HomeWorth): MortgageBalance {
  return value === '' ? "I don't have a mortgage" : value;
}

function convertToYesNo(value: YesNoNotSure): YesNo {
  return value === 'yes' ? value : 'no';
}

// TODO: Based on the logic on the backend a value has to be returned(even if the user selects that they are a renter)
function setHomeValueIfNoValueIsSet(value: HomeWorth): HomeWorth {
  return value === '' ? '$1-$24,999' : value;
}

export function manipulateData(
  data: CoverageCheckupState
): CoverageCheckupPayload {
  const {
    married,
    carOwned,
    autoInsurancePossessed,
    livingSituation,
    healthInsurancePossessed,
    lifeInsurancePossessed,
    disabilityInsurancePossessed,
    typeOfDisabilityInsurancePossessed,
    umbrellaInsurancePossessed,
    identityTheftProtectionPossessed,
    willPossessed,
    willPurchasedInSameStateAsResidence,
    dependents,
    hdhpPossessed,
    homeownersInsurancePossessed,
    willReflectsCurrentWishes,
    longTermCareInsurancePossessed,
    age,
    autoInsuranceLastReviewed,
    firstName,
    lastName,
    email,
    creditReportLastReviewed,
    employmentStatus,
    disabilityInsuranceLastReviewed,
    yearlyHouseholdIncome,
    nonRetirementSavings,
    retirementSavings,
    healthInsuranceLastReviewed,
    homeValue,
    mortgageBalance,
    homeownersInsuranceLastReviewed,
    identityTheftProtectionLastReviewed,
    typeOfLifeInsurancePossessed,
    lifeInsuranceLastReviewed,
    cancerInsurancePossessed,
    accidentalDeathInsurancePossessed,
    accidentOrSicknessInsurancePossessed,
    cellPhoneInsurancePossessed,
    homeWarrantyInsurancePossessed,
    mortgageLifeInsurancePossessed,
    petInsurancePossessed,
    noneOfThese,
    umbrellaInsuranceLastReviewed,
  } = data;
  return {
    married: convertToTrueFalse(married),
    dependents: convertToTrueFalse(dependents),
    age,
    car_owned: convertToTrueFalse(carOwned),
    auto_insurance_possessed: convertToTrueFalse(autoInsurancePossessed),
    timeframe_in_which_auto_insurance_last_reviewed: autoInsuranceLastReviewed,
    first_name: firstName,
    last_name: lastName,
    email,
    timeframe_in_which_credit_report_last_reviewed: creditReportLastReviewed,
    employment_status: employmentStatus, // lower case this value
    living_situation: livingSituation,
    disability_insurance_possessed: disabilityInsurancePossessed,
    timeframe_in_which_disability_insurance_last_reviewed:
      disabilityInsuranceLastReviewed,
    yearly_household_income: yearlyHouseholdIncome,
    non_retirement_savings: nonRetirementSavings,
    retirement_savings: retirementSavings,
    health_insurance_possessed: convertToTrueFalse(healthInsurancePossessed),
    hdhp_possessed: hdhpPossessed,
    timeframe_in_which_health_insurance_last_reviewed:
      healthInsuranceLastReviewed,
    home_value: setHomeValueIfNoValueIsSet(homeValue), // TODO: Research a better approach
    mortgage_balance: convertToMortgageBalance(mortgageBalance),
    homeowners_insurance_possessed: convertToTrueFalse(
      homeownersInsurancePossessed
    ),
    timeframe_in_which_homeowners_insurance_last_reviewed:
      homeownersInsuranceLastReviewed,
    identity_theft_protection_possessed: identityTheftProtectionPossessed,
    timeframe_in_which_identity_theft_protection_last_reviewed:
      identityTheftProtectionLastReviewed,
    will_possessed: convertToYesNo(willPossessed),
    will_purchased_in_same_state_as_current_residence:
      willPurchasedInSameStateAsResidence,
    will_reflects_current_wishes: willReflectsCurrentWishes,
    life_insurance_possessed: lifeInsurancePossessed,
    type_of_life_insurance_possessed: typeOfLifeInsurancePossessed,
    timeframe_in_which_life_insurance_last_reviewed: lifeInsuranceLastReviewed,
    long_term_care_insurance_possessed: longTermCareInsurancePossessed,
    cancer_insurance_possessed: convertBooleanToBinaryString(
      cancerInsurancePossessed
    ),
    accidental_death_insurance_possessed: convertBooleanToBinaryString(
      accidentalDeathInsurancePossessed
    ),
    accident_or_sickness_insurance_possessed: convertBooleanToBinaryString(
      accidentOrSicknessInsurancePossessed
    ),
    cell_phone_insurance_possessed: convertBooleanToBinaryString(
      cellPhoneInsurancePossessed
    ),
    home_warranty_insurance_possessed: convertBooleanToBinaryString(
      homeWarrantyInsurancePossessed
    ),
    mortgage_life_insurance_possessed: convertBooleanToBinaryString(
      mortgageLifeInsurancePossessed
    ),
    pet_insurance_possessed: convertBooleanToBinaryString(
      petInsurancePossessed
    ),
    none_of_these: convertBooleanToBinaryString(noneOfThese),
    timeframe_in_which_umbrella_insurance_last_reviewed:
      umbrellaInsuranceLastReviewed,
    umbrella_insurance_possessed: umbrellaInsurancePossessed,
    type_of_disability_insurance_possessed: typeOfDisabilityInsurancePossessed,
  };
}
